import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSkip: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconSkip"><Path d="M20 4.75C20 4.33579 19.6642 4 19.25 4C18.8358 4 18.5 4.33579 18.5 4.75V19.25C18.5 19.6642 18.8358 20 19.25 20C19.6642 20 20 19.6642 20 19.25V4.75Z" fill="currentColor"/><Path d="M6.72272 4.29409C5.579 3.53663 4 4.3268 4 5.73504V18.265C4 19.6732 5.579 20.4634 6.72272 19.7059L16.1825 13.4409C17.2189 12.7546 17.2189 11.2454 16.1825 10.5591L6.72272 4.29409Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSkip;
